import React from "react";

import { getFirestore } from "firebase/firestore";

import app from "../firebase";

import {
  SettableMetadata,
  deleteObject,
  getDownloadURL,
  getStorage,
  ref,
  updateMetadata,
  uploadBytes,
} from "firebase/storage";
import { Dev } from "../util/consoleUtil";
import firebaseError from "../util/firebaseError";

const db = getFirestore(app);
const storage = getStorage(app);

type AvailableBuckets = "temp" | "spott/approved" | "spott/disapproved";

export const StorageService = {
  Create: () => {
    const [isLoading, setLoading] = React.useState(false);

    const runRequest = async (
      fileBlob: File,
      bucket: AvailableBuckets,
      metadata?: SettableMetadata
    ) => {
      return new Promise<[string, string]>(async (Ok, Rej) => {
        try {
          setLoading(true);

          const storageRef = ref(storage, `${bucket}/${fileBlob.name}`);

          if (metadata) {
            await updateMetadata(storageRef, metadata);
          }

          const storageSnap = await uploadBytes(storageRef, fileBlob);

          const storageUrl = await getDownloadURL(storageRef);

          setLoading(false);

          Ok([storageSnap.ref.fullPath, storageUrl]);
        } catch (error) {
          console.log(...new Dev("Request Error [create]", error).Error());
          setLoading(false);
          Rej(new Error("Erro ao criar dados. " + firebaseError(error)));
        }
      });
    };

    return { isLoading, runRequest };
  },

  Delete: () => {
    const [isLoading, setLoading] = React.useState(false);

    const runRequest = async (fileRef: string) => {
      return new Promise(async (Ok, Rej) => {
        try {
          setLoading(true);

          const mainRef = ref(storage, fileRef);
          const mainSnap = await deleteObject(mainRef);

          setLoading(false);
          Ok(true);
        } catch (error) {
          console.log(...new Dev("Request Error [delete]", error).Error());
          setLoading(false);
          Rej(new Error("Erro ao remover dados. " + firebaseError(error)));
        }
      });
    };

    return { isLoading, runRequest };
  },
};
